import { useChat } from './use-chat';

export function MoniedeskChat() {
    useChat();

    return null;
}
